import { render, staticRenderFns } from "./PrivacyPolitic.vue?vue&type=template&id=de037ade"
import script from "./PrivacyPolitic.vue?vue&type=script&lang=js"
export * from "./PrivacyPolitic.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolitic.vue?vue&type=style&index=0&id=de037ade&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports